import type { Campaign } from '../../api/types';
import { useLoad } from '../../lib/useLoad';
import { useComms } from './context';

/**
 * The read behind the Bookings that followed card, held by Results rather than
 * by the card: the figures strip at the top quotes the same Booked count, and
 * two reads with two windows would put two different numbers for one question
 * on one screen. Null until the campaign has started — nobody has been sent
 * anything to book after.
 */
export function useCampaignBookings(campaign: Campaign | null, days: number) {
  const { source } = useComms();
  const id = campaign?.id ?? null;
  const started = Boolean(campaign?.startedAt);
  return useLoad(
    () => (id !== null && started ? source.api.getCampaignBookings(id, days) : Promise.resolve(null)),
    [source, id, days, started],
  );
}
